import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddCommunityLayer from "../components/AddFreeCommunityLayer";
 
 
const AddUpdates = () => {
  return (
    <>
   
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Free Community  </h5><Breadcrumb title="Add Free Community" /></div>
 
        {/* CalendarMainLayer */}
        <AddCommunityLayer />
 
 
    </>
  );
};
 
export default AddUpdates;
 
 